import React, { Component } from 'react'
import Breadcrumb from 'molecules/Breadcrumb'
import { toggleIsLoading } from 'Redux/actions/ViewStateActions'
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Footer, PageWrapper, ContainerBodyTable, FlexBetween } from './styles'
import { withRouter } from 'react-router'
import { withTheme } from 'styled-components'
import { permissionCheck } from 'helpers/permissionCheckHelper'
import {
  stockOpnameCreate,
  stockOpnameDelete,
  stockOpnameUpdate,
} from 'fixtures/permissions'
import ButtonReg from 'components/atoms/Buttons/Button'
import ImportExcelTablePreview from 'components/organisms/StockOpnameViewDetail/ImportExcelTablePreview'
import { ContainerHeaderData, Flex } from 'components/organisms/StockOpnameImport/styles'
import { Label } from 'components/atoms/Texts/TxtLabel'
import Attachments from 'components/organisms/StockOpnameViewDetail/Attachments'
import { COAL_STOCK_ATTACHMENT, COAL_STOCK_UPLOAD_ATTACHMENT, GET_VIEW_DETAIL } from 'fixtures/api'
import { getAllList, postNewData } from 'services/cmsService'
import lo from 'lodash';

export class StockOpnameViewUpload extends Component {
  constructor(props) {
    super(props)
    this.state = {
      allowCreate: false,
      allowDelete: false,
      allowUpdate: false,
      companyCode: null,
      period: null,
      currentDetail: {},
      form: []
    }
  }

  componentDidMount() {
    this.checkPermission()
    this.getId()
  }

  componentDidUpdate(prevProps) {
    const { userLogin } = this.props
    if (prevProps.userLogin !== userLogin) {
      this.checkPermission()
    }
  }

  checkPermission() {
    const { userLogin } = this.props
    if (userLogin && userLogin.userDetail) {
      const {
        userDetail: { permissions },
      } = userLogin
      this.setState({
        allowCreate: permissionCheck(permissions, stockOpnameCreate),
        allowDelete: permissionCheck(permissions, stockOpnameDelete),
        allowUpdate: permissionCheck(permissions, stockOpnameUpdate),
      })
    }
  }

  getId() {
    const { location } = this.props;
    const searchParams = new URLSearchParams(location.search);
  
    const companyCode = searchParams.get('companyCode');
    const period = searchParams.get('period');
  
    this.setState({
      companyCode,
      period
    });

    this.fetchDetail(companyCode, period)
  }

  onBack = () => {
    const { history: { push } } = this.props
    push('/dash/stock-opname')
  }

  onChange = async (val) => {
    const { toggleIsLoading } = this.props
    const { companyCode, period } = this.state
    
    const mappingBody = []
    const successFile = []

    val.forEach((el) => {
      mappingBody.push({
        body: {
          file: {
            filename: el.filename,
            base64: el.file
          },
          companyCode,
          period
        },
        value: el
      })
    })

    try {
      toggleIsLoading(true)
      for (const el of mappingBody) {
        const res = await postNewData(`${COAL_STOCK_UPLOAD_ATTACHMENT}`, el.body)
        if (res.status < 400) {
          successFile.push({
            ...el.value,
            id: res.data.id
          })
        } else {
          const message = res.message ? res.message : "Failed to upload"
          alert(message)
          throw res
        }
      }

      this.setState({ form: successFile })
    } catch (error) {
      alert(error)
    } finally {
      toggleIsLoading(false)
    }    
  }

  onChangeForm = (form) => {
    this.setState({ form })
  }

  buildParams = (companyCode, period) => {
    const paramsGet = {
      companyCode,
      period
    } 
    const filter = lo.omitBy({ ...paramsGet }, (val) => !val || val === '-')
    const params = new URLSearchParams(filter).toString()
    return params
  }

  fetchDetail = async (companyCode, period) => {
    const { toggleIsLoading } = this.props

    try {
      toggleIsLoading(true)

      if (companyCode && period) {
        const params = this.buildParams(companyCode, period)
        const dataApi = await getAllList(`${GET_VIEW_DETAIL}?${params ? `${params}` : ''}`)
        this.setState({
          currentDetail: dataApi
        })

        this.fetchAttachment(companyCode, period)
      }
    } catch (error) {
      return
    }
  }

  fetchAttachment = async (companyCode, period) => {
    const { toggleIsLoading } = this.props

    try {
      if (companyCode && period) {
        const params = this.buildParams(companyCode, period)
        const dataApi = await getAllList(`${COAL_STOCK_ATTACHMENT}?${params ? `${params}` : ''}`)
        this.setState({ form: dataApi })
      }
    } catch (error) {
      return
    } finally {
      toggleIsLoading(false)
    }
  }

  render() {
    const navList = [
      'Stock Opname',
      `Stock Opname View Detail`,
    ]
    const {
      viewState: { isMobileView },
    } = this.props

    const { form, id, allowUpdate, currentDetail } = this.state

    return (
      <PageWrapper isMobile={isMobileView}>
        <Breadcrumb navList={navList} />
        <ContainerHeaderData>
          <FlexBetween>
            <div>
              <Flex>
                <Label mr={'15px'} mb={'0px'} size={'12px'}>Company</Label>
                <Label size={'12px'} mb={'0px'} mr={'100px'} weight={100}>{currentDetail.companyCode}</Label>
              </Flex>
              </div>
              <div>
                <Flex>
                  <Label mr={'10px'} mb={'0px'} size={'12px'}>Periode</Label>
                  <Label size={'12px'} mb={'0px'} weight={100}>{currentDetail.period}</Label>
                </Flex>
            </div>
          </FlexBetween>
        </ContainerHeaderData>
        <Attachments
          form={form}
          onChange={this.onChange}
          onChangeForm={this.onChangeForm}
          enableField={id ? allowUpdate : true}
        />
        <ContainerBodyTable>
          <ImportExcelTablePreview coalStockInventories={currentDetail.coalStockInventories || []} />
        </ContainerBodyTable>
        <Footer>
          <ButtonReg
            transparent
            btnTxt={'Back'}
            onClick={() => this.onBack()}
            width={'150px'}
            margin="0 10px 0 0"
          />
        </Footer>
      </PageWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userLogin: state.userLogin,
    viewState: state.viewState,
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      toggleIsLoading,
      setLocalSettingsTableData,
    },
    dispatch
  )

export default withRouter(
  withTheme(connect(mapStateToProps, mapDispatchToProps)(StockOpnameViewUpload))
)
